var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3673 2.61352C18.1561 1.82327 17.5338 1.201 16.7436 0.989821C15.3111 0.605957 9.56788 0.605957 9.56788 0.605957C9.56788 0.605957 3.82462 0.605957 2.39215 0.989821C1.60208 1.201 0.979664 1.82327 0.768451 2.61352C0.384766 4.04581 0.384766 7.03422 0.384766 7.03422C0.384766 7.03422 0.384766 10.0226 0.768451 11.4548C0.979664 12.245 1.60208 12.8674 2.39215 13.0786C3.82462 13.4623 9.56788 13.4623 9.56788 13.4623C9.56788 13.4623 15.3111 13.4623 16.7436 13.0786C17.5338 12.8674 18.1561 12.245 18.3673 11.4548C18.7511 10.0226 18.7511 7.03422 18.7511 7.03422C18.7511 7.03422 18.7511 4.04581 18.3673 2.61352V2.61352Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73828 9.7927L12.5099 7.03771L7.73828 4.28271V9.7927V9.7927Z",
    fill: "#ED474C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4cb7f096963276daba69ae9b5ad4a4ef.svg";
export { ForwardRef as ReactComponent };